<div class="denied-container">
    <div class="denied-text">
        <div>You do not have access to this page</div>
        <div>To return home click <a (click)="goHome()">here</a></div>
        <div>To log out click <a (click)="logout()">here</a></div>
    </div>
</div>
